import {useGetDiscountCodesContext} from "../context";
import {GetDiscountCodesEmptyState} from "../empty-state";
import {DiscountCodesPageLayout} from "../layout";
import {DiscountCodesTableV2} from "../table-v2";

export function DiscountCodesPage() {
  const {
    state: {discountCodes},
  } = useGetDiscountCodesContext();
  const hasDiscountCodes = discountCodes.length > 0;
  return (
    <DiscountCodesPageLayout>
      {hasDiscountCodes ? <DiscountCodesTableV2 /> : <GetDiscountCodesEmptyState />}
    </DiscountCodesPageLayout>
  );
}
